import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import PinInput from "react-pin-input";
import { i18n } from "../../../private/languageSelector";
import { useSelector } from "react-redux";

export default function PosPinModal({ show, onHide, onSubmit, setPosPin }) {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const { language } = useSelector((state) => state.auth);
  return (
    <div>
      <Modal
        className="shadow-md pospin-modal-custom"
        size="sm"
        aria-labelledby="example-modal-sizes-title-lg"
        show={show}
        onHide={() => onHide}
        centered
      >
        <Modal.Body>
          <div className={`new-pin-text mb-5 pb-5 mx-3 ${language === "arabic" ? "rtl" : "ltr"}`}>{i18n("global.EnterNewPin")}</div>
          <PinInput
            length={4}
            initialValue=""
            enforceFocus={true}
            onChange={(value) => {
              setPosPin(value);
              if (value?.length === 4) {
                setIsButtonDisabled(false);
              } else {
                setIsButtonDisabled(true);
              }
            }}
            focus={true}
            autoFocus={true}
            secret={false}
            type="numeric"
            style={{ width: "100%" }}
            inputStyle={{
              width: "50px",
              height: "50px",
              border: "0",
              marginLeft: "1rem",
              marginRight: "1rem",
              fontSize: "25px",
              background: "#F2F2F2",
              color: "#333333",
              direction: "ltr",
            }}
          />
          <div className={`pos-pin-modal-actions mt-5 pt-5 mx-3 ${language === "arabic" ? "rtl" : "ltr"} `}>
            <button className="cancel-pin-text" onClick={onHide}>
              {i18n("SubscriptionModals.CANCEL")}{" "}
            </button>
            <button className="confirm-pin-text" disabled={isButtonDisabled} onClick={onSubmit}>
              {i18n("SubscriptionModals.CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
